import ApplyRounding from '../../../../../../utils/math/ApplyRounding';

export function determineDistanceToTrigger(last, sortingDetails) {
  let distanceToTrigger = 'none';
  let triggerPrice = 'none';
  let direction = 'up';
  if (sortingDetails && last) {
    if (sortingDetails.triggerPrice) {
      const { priceToBreak, priceToBreakHigh, priceToBreakLow } =
        sortingDetails.triggerPrice;
      if (priceToBreak) {
        triggerPrice = priceToBreak;
        if (Number(triggerPrice) < Number(last)) {
          direction = 'down';
        }
        distanceToTrigger = ApplyRounding(Math.abs(last - triggerPrice), 2);
      }
      if(priceToBreakHigh && priceToBreakLow  && last && !isNaN(last)){
        if(priceToBreakHigh - last < last - priceToBreakLow ){
          triggerPrice = priceToBreakHigh;
          direction = 'up';
          distanceToTrigger = ApplyRounding(triggerPrice - last, 2);
        } else {
          triggerPrice = priceToBreakLow;
          direction = 'down';
          distanceToTrigger = ApplyRounding(last - triggerPrice, 2);
        }
      }
      if (priceToBreakHigh && last && !isNaN(last)) {
        triggerPrice = priceToBreakHigh;
        direction = 'up';
        distanceToTrigger = ApplyRounding(triggerPrice - last, 2);

      } else if (priceToBreakLow && last && !isNaN(last)) {
        triggerPrice = priceToBreakLow;
        direction = 'down';
        distanceToTrigger = ApplyRounding((last - triggerPrice), 2);
      }
    }
    // if (triggerPrice && triggerPrice !== 'none' && last && !isNaN(last)) {
    //   distanceToTrigger =
    //     ApplyRounding(Math.abs(last - triggerPrice), 2) +
    //     `${direction ? '\u00A0' + direction : ''}`;
    // }
  }
  return [distanceToTrigger, direction];
}
